import Logout from './containers/LogoutContainer'

export default {
  path: '/logout',
  component: Logout
}



// WEBPACK FOOTER //
// ./src/routes/logout/index.js